import axios from 'axios';
import {
  ArgsGetStats,
  ArgsGetStatsV2,
  StatsAnalyse,
  StatsInscriptions,
  StatsSalon,
} from '~/types/stats';

export const getStatsList = async () => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/stats/list`,
    {
      headers: {
        Authorization: token,
      },
    },
  );
  return data?.lists;
};

export const getStats = async (params: ArgsGetStats) => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/stats`,
    {
      headers: {
        Authorization: token,
      },
      params,
    },
  );
  return data?.stats;
};

export const getStatsInscriptions = async (
  params: ArgsGetStatsV2,
): Promise<StatsInscriptions | null> => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/stats/inscriptions`,
    {
      headers: {
        Authorization: token,
      },
      params,
    },
  );
  return data?.stats ?? null;
};

export const getStatsSalon = async (
  params: ArgsGetStatsV2,
): Promise<StatsSalon | null> => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/stats/salon`,
    {
      headers: {
        Authorization: token,
      },
      params,
    },
  );
  return data?.stats ?? null;
};

export const getStatsAnalyse = async (
  params: ArgsGetStatsV2,
): Promise<StatsAnalyse | null> => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  const { data } = await axios.get(
    `${process.env.REACT_APP_API_URL}/stats/analyse`,
    {
      headers: {
        Authorization: token,
      },
      params,
    },
  );
  return data?.stats ?? null;
};
